"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const shiftAndModulo_1 = __importDefault(require("./shiftAndModulo"));
/**
 * Calculate the factors that determine the personality.
 * @param source Source for calculation.
 * @returns Intermediate values that determine the factors of personality.
 */
exports.default = (source) => {
    const { date, month: { early, month, shifted }, monthlyCoefficient: monthlyCoefficients, year: { full, hi, lo }, } = source;
    const lessThan = date < monthlyCoefficients;
    const outer = shiftAndModulo_1.default(month - (lessThan ? 1 : 0), 12) + 1;
    const workStyle = full + 9 - early(lessThan);
    const cycle = new Int32Array([hi * 4.25, (shifted + 1) * 0.6]).reduce((acc, cur) => acc + cur, Math.floor((lo - early()) * 5.25) + date + 7);
    const potentials = [workStyle - 2, full * 2 + outer + 2].map((v) => shiftAndModulo_1.default(v, 10));
    return {
        cycle: shiftAndModulo_1.default(cycle, 10),
        getXY: (value) => ({ x: value - 1, y: cycle % 10 }),
        inner: shiftAndModulo_1.default(shifted * 6 + hi * 4 + cycle - 6, 12),
        lifeBase: date - monthlyCoefficients,
        outer: shiftAndModulo_1.default(outer, 12),
        potentials: [potentials[0], potentials[1]],
        workStyle: shiftAndModulo_1.default(workStyle, 12),
    };
};
//# sourceMappingURL=getFactors.js.map